module.exports = __webpack_public_path__ + "static/img/og-image.616ee95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/og-image.jpg
// module id = ADRM
// module chunks = 0